<template>
    <section>
        <div class=" flex">
            <router-link to="/admin/message">
                <div class="relative">
                    <i class=" fa fa-envelope mt-1 text-blue-700 fa-2x"></i>
                    <p class=" absolute top-0 left-5 border bg-blue-700 w-5 h-5 text-center text-xs rounded-full text-white">{{noOfMessages}}</p>
                </div>
            </router-link>    

            <!-- <div class="relative ml-4">
                <i class=" fa fa-bell mt-1 text-blue-700 fa-2x"></i>
                <p class=" absolute top-0 left-5 border bg-blue-700 w-5 h-5 text-center text-xs rounded-full text-white">{{noOfMessages}}</p>
            </div> -->

            <div class=" flex ml-8">
                <!-- <img src="./assets/customer-pic1.png" alt="customer-pic"> -->
                <i class="fa fa-user fa-2x text-blue-500  rounded-full "></i>
                <div class="text-blue-700 ml-2">
                    <p>{{userName}} </p>
                    <p>{{userType}}</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import {baseUrl} from '../../Config';
const url = baseUrl;
export default {
    data() {
        return {
            userName : localStorage.getItem('userEmail'),
            userType : localStorage.getItem('userType'),
            noOfMessages: "",
            userId: localStorage.getItem('userId'),
        }
    },

    mounted() {
        this.getMessages()
    },

    methods: {
        getMessages() {
           
            axios({
                method: 'GET',
                url: `${url}/v1/web/chats/${this.userId}?sortBy=name&limit=20&page=1`,
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer' + localStorage.getItem("token"),
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
            })
            .then((response) => {
                let message = response.data.data.results
                this.noOfMessages = message.length;                

            })
            .catch((error) => {
                error.json
            })
        },
    }
    
}
</script>